module.exports = __webpack_public_path__ + "static/media/master-service.056c68c0.svg";